export default (node: Element, classes: string | string[]): void => {
  node.classList.add(...(Array.isArray(classes) ? classes : classes.split(' ')));
};
